/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Component,
  AfterViewInit,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
} from 'rxjs/operators';
import { NgbActiveModal, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { BrowserService } from '../../../services/browser.service';
import { XdaStringsService } from '../../../services/xda-strings.service';
import { StandardField } from '../xrx-redact.component';

@Component({
  selector: 'standard-redaction-fields-modal-component',
  templateUrl: './standard-redaction-fields-modal.component.html',
  styleUrls: ['./standard-redaction-fields-modal.component.less'],
  standalone: false,
})
export class StandardRedactionFieldsModalComponent
  implements AfterViewInit, OnDestroy
{
  @ViewChild('searchInput', { static: true }) input: ElementRef;
  private subscription: Subscription;

  isMfd: boolean;
  title = 'SDE_STANDARD_REDACTION_ITEMS';
  uiLang: string;
  placeholder = 'SDE_SEARCH';
  list: any[];
  displayList: any[];
  searchTerm: string;
  scrollClass = '';

  constructor(
    public activeModal: NgbActiveModal,
    private xdaStringsService: XdaStringsService,
    private ngbPopoverConfig: NgbPopoverConfig,
    private browserService: BrowserService,
  ) {
    this.ngbPopoverConfig.popoverClass = 'xrx-popover';
    this.title = this.xdaStringsService.strings[this.title];
    this.placeholder = this.xdaStringsService.strings[this.placeholder];
    this.uiLang = this.xdaStringsService.strings['UILANG'];
    this.displayList = this.list;
    this.scrollClass =
      this.browserService?.browserType() < 3 ? '' : 'nativeScroll';
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
    const terms$ = fromEvent<any>(this.input.nativeElement, 'keyup').pipe(
      map((event) => event.target.value),
      startWith(''),
      debounceTime(200),
      distinctUntilChanged(),
    );

    this.subscription = terms$.subscribe((filterStr) => {
      this.displayList = this.list.filter(
        (x) =>
          x.displayText.toLowerCase().indexOf(filterStr.toLowerCase()) > -1,
      );
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  rowClicked(item: StandardField) {
    item.preferred = !item.preferred;
  }
}
